/* ============================================================================
 * SYLONI® · Tilt Glass Card (Sprint 3 / Batch 1)
 *
 * 鼠标在卡片上移动时卡片 3D 倾斜 + 光斑跟随鼠标。
 *
 * Application:
 *   - Explicit opt-in via data-syloni-tilt attribute
 *   - syloni-auto-hooks.js auto-attaches to .product-card / .collection-card / .review
 *
 * Per-element configuration via data attributes (optional):
 *   - data-tilt-max (default 10) · 最大倾斜角度
 *   - data-tilt-scale (default 1.02) · hover 时缩放
 *
 * Auto-disabled on:
 *   - prefers-reduced-motion: reduce
 *   - .syloni-no-motion / .syloni-touch-device on <html>
 *
 * Last update: 2026-04-27 · Batch 1 v0.4.0
 * ============================================================================ */

(function () {
  'use strict';

  const SELECTOR = '[data-syloni-tilt]';
  const MAX_DEFAULT = 10;
  const SCALE_DEFAULT = 1.02;
  const instances = new WeakMap();

  class TiltCard {
    constructor(el) {
      this.el = el;
      this.max = parseFloat(el.dataset.tiltMax) || MAX_DEFAULT;
      this.scale = parseFloat(el.dataset.tiltScale) || SCALE_DEFAULT;

      this._boundMove = this._handleMove.bind(this);
      this._boundLeave = this._handleLeave.bind(this);

      el.classList.add('syloni-tilt-card');
      el.addEventListener('mousemove', this._boundMove);
      el.addEventListener('mouseleave', this._boundLeave);
    }

    _handleMove(e) {
      const r = this.el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width;
      const py = (e.clientY - r.top) / r.height;
      const rx = (py - 0.5) * -this.max * 2;
      const ry = (px - 0.5) * this.max * 2;

      this.el.style.transform = `perspective(900px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) scale(${this.scale})`;
      this.el.style.setProperty('--syloni-tx', (px * 100).toFixed(1) + '%');
      this.el.style.setProperty('--syloni-ty', (py * 100).toFixed(1) + '%');
      this.el.style.setProperty('--syloni-tilt-active', '1');
    }

    _handleLeave() {
      this.el.style.transform = '';
      this.el.style.setProperty('--syloni-tilt-active', '0');
    }

    destroy() {
      this.el.removeEventListener('mousemove', this._boundMove);
      this.el.removeEventListener('mouseleave', this._boundLeave);
      this.el.style.transform = '';
      this.el.classList.remove('syloni-tilt-card');
    }
  }

  function shouldSkip() {
    const html = document.documentElement;
    return (
      html.classList.contains('syloni-no-motion') ||
      html.classList.contains('syloni-touch-device') ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initAll(scope) {
    if (shouldSkip()) return;
    const root = scope || document;
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (instances.has(el)) return;
      instances.set(el, new TiltCard(el));
    });
  }

  function destroyEl(el) {
    const inst = instances.get(el);
    if (inst) {
      inst.destroy();
      instances.delete(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector) initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target) {
      const els = e.target.querySelectorAll
        ? e.target.querySelectorAll(SELECTOR)
        : [];
      els.forEach(destroyEl);
    }
  });

  if (window.SYLONI) {
    window.SYLONI.modules.tilt = {
      version: '0.4.0',
      initAll,
      destroyEl,
      instances,
    };
  }

  console.log(
    '%c SYLONI tilt v0.4.0 ',
    'background:#D4AF37;color:#0A0A0A;padding:3px 8px;font-family:monospace;letter-spacing:2px;font-weight:600;'
  );
})();
